import React, { useEffect } from "react";
import { PageHeader } from "../../components";
import DashboardStats from "./DashboardStats";
import EventsCard from "./EventsCard";
import FinancialProjection from "./FinancialProjection";
import ManageQueries from "./ManageQueries";
import LeaveRequest from "./LeaveRequest";
import WeeklySchedule from "./WeeklySchedule";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useSelector } from "react-redux";
import { fetchDashboardData } from "../../features/dashboard/dashboardSlice";
import { useBranchCode } from "../../util/hooks/useBranch";

export default function Home() {
  const dispatch = useDispatch<AppDispatch>();
  const { data, loading } = useSelector((state: RootState) => state.dashboard);

  const branchCode = useBranchCode();

  const user = useSelector((state: RootState) => state.access.staff);

  const isAdmin =
    user?.roleName === "ROLE_ADMIN" || user?.roleName === "ROLE_SUPER_ADMIN";

  useEffect(() => {
    dispatch(fetchDashboardData({ branchCode }));
  }, [dispatch, branchCode]);

  return (
    <div className="flex flex-col lg:flex-row gap-3">
      <div className="flex flex-col gap-3 w-full">
        <PageHeader title="DASHBOARD" />
        {isAdmin && (
          <>
            <DashboardStats counts={data?.counts} />
            <FinancialProjection
              data={Object.entries(data?.revenueChart || {}).map(
                ([month, value]) => ({ name: month, value, dotted: 0 }),
              )}
            />
          </>
        )}
        <WeeklySchedule />
      </div>
      <div className=" md:max-w-[350px] flex flex-col gap-3 w-full">
        <EventsCard />
        <div className="flex flex-col gap-3 pr-3">
          {isAdmin && <ManageQueries queries={data?.latestQueries} />}
          <LeaveRequest leaveRequests={data?.topPendingLeaveRequests || []} />
        </div>
      </div>
    </div>
  );
}
